import { render, staticRenderFns } from "./FundsLetter.vue?vue&type=template&id=6cc80210"
import script from "./FundsLetter.vue?vue&type=script&lang=js"
export * from "./FundsLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports